export default __webpack_public_path__ + "static/media/NGORealCase2-moblie-en.e315287d.jpg";